import { Icon, Text, HStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

export const ProfitabilityText: React.FC<{ profitability: number }> = ({ profitability }) => {
  const profitabilityNormalized = Utils.Mask.Percentage(profitability);

  return (
    <HStack space="stack.quarck" width="full">
      <Icon
        name={profitability < 0 ? 'ArrowDown' : 'ArrowUp'}
        size="xxxs"
        color={profitability < 0 ? 'feedback.error.default' : 'feedback.success.default'}
      />
      <Text>{profitabilityNormalized}</Text>
    </HStack>
  );
};
